<div class="flex-container flex wrapper-sm condition-monitoring-details">
    <div class="flex-container-column flex">
        <div [ngClass]="{processing: (isProcessing)}" class="flex-none ng-scope">
            <div></div>
        </div>
        <kendo-tabstrip (tabSelect)="onTabSelect($event)" *ngIf="hasTabs">
            <kendo-tabstrip-tab *ngFor="let tabName of tabNames; let i = index" title="{{tabName | xlat}}" [selected]="tabSelected(i)">
                <ng-template kendoTabContent>
                    <div class="content" *ngIf="currentVehicle$">
                        <ng-container [ngSwitch]="getTabType(i)">
                            <condition-details *ngSwitchCase="0" [vehicle]="vehicle"
                                            [currentVehicle$]="currentVehicle$"
                                            [currentVehicle]="currentVehicle"
                                            (updateSelectedComponent)="updateSelectedComponent($event)"
                                            (finishedProcessing)="onDoneProcessing($event)"></condition-details>
                            <visual-inspections *ngSwitchCase="1"  [vehicle]="vehicle"
                                            [currentVehicle$]="currentVehicle$"
                                            [currentVehicle]="currentVehicle"
                                            (updateSelectedComponent)="updateSelectedComponent($event)"
                                            (finishedProcessing)="onDoneProcessing($event)"></visual-inspections>
                            <thread-wear *ngSwitchCase="2" [vehicle]="vehicle"
                                            [currentVehicle$]="currentVehicle$"
                                            [currentVehicle]="currentVehicle"
                                            [rendererConfig]="rendererConfig"
                                            (updateSelectedComponent)="updateSelectedComponent($event)"
                                            (finishedProcessing)="onDoneProcessing($event)"></thread-wear>
                        </ng-container>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [title]="plannedWorkDetails">
                <ng-template kendoTabContent>
                    <div class="content"
                         style="height: 400px; display: flex;flex-direction: column;justify-content: center;">
                        <div style="display: flex;justify-content: center;">
                            <div>{{comingSoon}}...</div>
                        </div>
                    </div>
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
    </div>
</div>
